import * as actionTypes from './actionTypes';

export const errorClear = () => {
    return {
        type: actionTypes.ERROR_CLEAR
    };
};
